// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Box, CircularProgress } from '@mui/material';
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { selectProtectedMenus } from '../store/slices/database/menuConfigSlice';

export default function ProtectedRoute({ children, roles = [], authOnly = false }) {
  const { isAuthenticated, isLoading } = useAuth();
  const keycloakAuth = useAuth(); // Add this to fix the logout button
  const location = useLocation();
  const userAllowedRoutes = useSelector(selectProtectedMenus);

  // Show loading while checking auth status
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Routes marked authOnly (e.g. company selection) skip the role check —
  // they must be reachable before userAllowedRoutes is populated.
  if (authOnly) return children;

  // Check if user has access to the current route
  const allowedPaths = userAllowedRoutes
    ?.filter(route => route.to)
    .map(route => route.to) || [];

  const hasRequiredRoles = allowedPaths.includes(location.pathname);

  if (!hasRequiredRoles) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
        padding: '20px'
      }}>
        <h2>Access Denied</h2>
        <p>You don't have permission to access this page.</p>
        {/* <p>Required roles: {roles.join(', ')}</p> */}
        <button
          onClick={() => keycloakAuth.logout()}
          style={{
            backgroundColor: '#dc3545',
            color: 'white',
            padding: '12px 24px',
            border: 'none',
            borderRadius: '5px',
            fontSize: '16px',
            cursor: 'pointer',
            marginTop: '20px'
          }}
        >
          Logout
        </button>
      </div>
    );
  }

  // If authenticated, render the protected content
  return children;
}